//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Section.js";
import "../Features/Features.SelectFeature.js";
import "../Facet/Facet.SelectFacetedBody.js";
import "../no/SelectBody.js";
import "../no/ugmath.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"AngleTolerance",1,0],[0,"CalculateMaxDeviation",1,0],[0,"ConvexityDirection",1,"Direction",0],[0,"ConvexityEnabled",1,0],[0,"CreateFacets",1,0],[0,"DefinedBy",1,0],[0,"DeformationFactor",1,0],[0,"Degree",1,0],[0,"DistanceTolerance",1,0],[0,"Divisions",1,0],[0,"DrawVector",1,"Direction",0],[1,"InnerCurve",0,"Section",0],[0,"IsGlobalDeformation",1,0],[1,"OneStep",0,"Features.SelectFeature",0],[1,"OuterCurve",0,"Section",0],[1,"ProductFacets",0,"Facet.SelectFacetedBody",0],[0,"ProductPointsFile",1,0],[1,"ProductSheet",0,"SelectBody",0],[0,"ResultType",1,0],[0,"ShapeValue",1,0],[0,"SmoothingFactor",1,0],[1,"SprungFacets",0,"Facet.SelectFacetedBody",0],[0,"SprungPointsFile",1,0],[0,"StepSize",1,0]],[[["num_product_points","product_points"],"GetProductPoints",{},0,0],[["product_points"],"SetProductPoints",{},1,0],[["num_sprung_points","sprung_points"],"GetSprungPoints",{},0,0],[["sprung_points"],"SetSprungPoints",{},1,0]],[]];
SPLM.Die.SpringbackCompensationBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.SpringbackCompensationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.SpringbackCompensationBuilder.DefinedByType = Object.freeze({
    "OneStepFeature" : "OneStepFeature", "FacetedBodies" : "FacetedBodies", "Points" : "Points"});

SPLM.Die.SpringbackCompensationBuilder.ResultSheetType = Object.freeze({
    "Compensated" : "Compensated", "Sprung" : "Sprung"});

SPLM.Die.SpringbackCompensationBuilder.DegreeType = Object.freeze({
    "Two" : "Two", "Three" : "Three", "Five" : "Five", "Seven" : "Seven"});

export default SPLM;